
export default {
    namespaced: true,
    state: {
        languages: [],
    },
    getters: {
        DATA: state => {
            return state.languages;
        },
    },
    mutations: {
        SET_DATA: (state, payload) => {
            return state.languages = payload;
        },
    },
    actions: {
        GET_DATA: async ({commit}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/language',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    console.log('responseData language')
                    console.log(responseData)
                    commit('SET_DATA', responseData.data);
                    payload.th.isReady = true
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        }
    }
}